import React from "react";

type Props = {
  name: string;
  label: string;
  type?: string;
  required?: boolean;
  placeholder?: string;
  skipAutoFocus?: boolean;
  defaultValue?: string;
};

class FormTextField extends React.Component<Props> {
  inputRef: HTMLInputElement | null = null;

  setInputRef = (element: HTMLInputElement | null) => {
    this.inputRef = element;
  };

  componentDidMount() {
    if (this.inputRef && !this.props.skipAutoFocus) {
      this.inputRef.focus();
    }
  }

  componentDidUpdate(prevProps: Props) {
    // Focus input if focus prop changes from true to false
    if (this.inputRef && prevProps.skipAutoFocus && !this.props.skipAutoFocus) {
      this.inputRef.focus();
    }
  }

  render() {
    const { name, label, type, required, placeholder, defaultValue } =
      this.props;
    const id = name.replace("[", "_").replace("]", "");
    return (
      <div className="form-group">
        <label htmlFor={id}>{label}</label>
        <div className="row">
          <div className="col-sm-6">
            <input
              type={type || "text"}
              name={name}
              id={id}
              required={required}
              placeholder={placeholder}
              ref={this.setInputRef}
              defaultValue={defaultValue}
              className="form-control"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default FormTextField;
